import Axios from "axios";
import { SET_NOMINEE_LIST, UNSET_NOMINEE_LIST } from "@/store/mutation-types";

import { saveUpdateHrmNominee, getHrmNomineeList } from "@/store/api";

// initial state
const state = {
    getHrmNomineeList: [],
    editingNominee: null,
}

const getters = {
    getHrmNomineeList(state){
        return state.getHrmNomineeList;
    },
    getEditingNominee: (state) => { 
        return state.editingNominee;
    },
}

const mutations = {
    [SET_NOMINEE_LIST](state, data) {
        state.getHrmNomineeList = data;
    },
    [UNSET_NOMINEE_LIST](state) {
        state.getHrmNomineeList = [];
    },
    setEditingNominee(state, nominee) {
        state.editingNominee = nominee;
    }
}

const actions = {
    saveUpdateHrmNominee({ commit }, formData) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
        Axios.post(saveUpdateHrmNominee, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then((response) =>{
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
            .finally(() => {
                commit("UNSET_LOADING");
            });
    });
},


    getHrmNomineeList({ commit }) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getHrmNomineeList)
                .then(function (response) {
                    commit(SET_NOMINEE_LIST, response.data.data);
                    resolve(response.data.data);  
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
};